import { Actions, ofType, createEffect } from '@ngrx/effects';
import { switchMap } from 'rxjs/operators';
import { EBalanceActions, GetBalance, GetBalanceSuccess,  } from '../actions/balance.actions';
import { Injectable } from '@angular/core';
import { IBalance } from 'src/app/models/balance.interface';
import { of } from 'rxjs';
import { IdentifyService } from 'src/app/service/http/identify/identify.service';


@Injectable()
export class BalanceEffects {
  
  getBalance$ = createEffect(() => this._actions$.pipe(
    ofType<GetBalance>(EBalanceActions.GetBalance),
    switchMap((action) => this._indentifyService.getBalance(action.payload)),
    switchMap((balance: IBalance) => {
      return of(new GetBalanceSuccess(balance));
    })
  ));

  constructor(
    private _indentifyService: IdentifyService,
    private _actions$: Actions) {}
}
